import { Grid } from "modules/common/components/Grid";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { Flex, Heading, Text, Box } from "@chakra-ui/react";
import type { HeroProps } from "./Hero.d";
import { textStyles, linkStyles } from "./Hero.styles";

const Hero = ({ heading, subHeading, text, link }: HeroProps) => (
  <Grid mb={{ base: 14, lg: 24 }}>
    <Box gridColumn={{ base: "span 1", md: "span 12" }}>
      <Flex flexDir="column" align={{ base: "flex-start", lg: "center" }}>
        {subHeading && (
          <Text
            color="primary.500"
            fontSize="sm"
            mb={2}
            textTransform="uppercase"
            fontWeight="bold"
            letterSpacing="wide"
          >
            {subHeading}
          </Text>
        )}
        {heading && (
          <Heading variant="h1" as="h1" mb={6}>
            {heading}
          </Heading>
        )}
        <RichtextAdapter content={text} customStyles={textStyles} />
        {link && <RichtextAdapter content={link} customStyles={linkStyles} />}
      </Flex>
    </Box>
  </Grid>
);

export default Hero;
